import Vue from 'vue'
import Vuex from 'vuex'

import { fetchHttpData as $fetchHttpData } from '@/config/network/httpService'
import { isEmpty } from 'lodash'

/*
  프로모션 메뉴(카테고리) 스토어
    - getName 함수 필수 구현
    - createInstance 함수 필수 구현
*/

/*
  return
   - vue intance를 식별하기 위한 unique id
*/
const getName = () => {
  return 'courseList'
}

/*
   return
    - localstore 저장용 vue instance
*/
const createInstance = () => {
  let localStore = ''

  if (window.vue.getStore(getName) === undefined) {
    const store = new Vuex.Store({
      state: {
        initFlag: false, // 초기화시 사용:true일 경우만 fectch, 초기화 진행시 = false, 초기화 완료시 = true
        fetchFlag: false, // 데이터 변경 전용 조회 플래그
        where: {
          prdtAttrTyp: [], // F:대면,L:실시간,E:일반이러닝 (CD_PPD_0167)
          diflvTyp: [], //  초급:01, 중급:02, 고급:03 (CD_PPD_0014)
          txtbkYn: '', // 교재제공유무
          orderby: '01' // 통합검색 : [관련도순(01), 가나다순(02), 최신순(03), 평점순(04)] 카테고리 검색 : [신청가능순(01), 추천순(02), 최신순(03), 제목순(04), 평점순(05)]
        },
        pageInfo: {
          pageNum: 1, // 현재 페이지
          cntPerPage: 20 // 페이지에 표시될 항목수
        },
        resultInfo: {
          corsList: [], // 과정 목록
          bannerList: [],
          totCnt: 0, // 과정 결과 갯수
          clsfNm: '', // 과정 분류명
          depthClsfNm: '', // 과정 분류명(뎁스)
          clsfCd: '', // 과정 분류 코드
          searchText: '' // 통합검색어
        },
        portletList: ''
      },
      getters: {
        initFlag: state => state.initFlag,
        fetchFlag: state => state.fetchFlag,
        where: state => state.where,
        pageInfo: state => state.pageInfo,
        resultInfo: state => state.resultInfo
      },
      mutations: {
        SET_INIT_FLAG (state, initFlag) {
          state.fetchFlag = initFlag
        },
        SET_FETCH_FLAG (state, fetchFlag) {
          state.fetchFlag = fetchFlag
        },
        SET_WHERE (state, where) {
          state.where = where
        },
        SET_TOTAL_RESULT_INFO (state, { filteredList, totCnt }) {
          state.resultInfo.corsList = [...state.resultInfo.corsList, ...filteredList]
          state.resultInfo.totCnt = totCnt
          console.log('총 통합 갯수 실제: ', state.resultInfo.corsList.length, state.resultInfo.corsList)
        },
        SET_CORS_RESULT_INFO (state, { courseList, totCnt, clsfNm, depthClsfNm, bannerList }) {
          state.resultInfo.corsList = [...state.resultInfo.corsList, ...courseList]
          state.resultInfo.clsfNm = clsfNm
          state.resultInfo.depthClsfNm = depthClsfNm
          state.resultInfo.totCnt = totCnt
          state.resultInfo.bannerList = bannerList
          console.log('총 cors 갯수 실제: ', state.resultInfo.corsList.length, state.resultInfo.corsList)
        },
        SET_PAGE_INFO (state, pageInfo) {
          state.pageInfo = pageInfo
        },
        SET_PORTLET_LIST (state, portletList) {
          state.portletList = portletList
        },
        CLEAR_WHERE (state) {
          state.initFlag = false // 초기화시 사용:true일 경우만 fectch, 초기화 진행시 = false, 초기화 완료시 = true
          state.fetchFlag = false // 데이터 변경 전용 조회 플래그
          state.where = {
            prdtAttrTyp: [], // F:대면,L:실시간,E:일반이러닝 (CD_PPD_0167)
            diflvTyp: [], //  초급:01, 중급:02, 고급:03 (CD_PPD_0014)
            txtbkYn: '', // 교재제공유무
            orderby: '01' // 통합검색 : [관련도순(01), 가나다순(02), 최신순(03), 평점순(04)] 카테고리 검색 : [신청가능순(01), 추천순(02), 최신순(03), 제목순(04), 평점순(05)]
          }
        },
        CLEAR_PAGE_INFO (state) {
          state.pageInfo = {
            pageNum: 1, // 현재 페이지
            cntPerPage: 20 // 페이지에 표시될 항목수
          }
        },
        CLEAR_RESULT_INFO (state) {
          state.resultInfo = {
            corsList: [], // 과정 목록
            bannerList: [], // 배너 목록
            totCnt: 0, // 과정 결과 갯수
            clsfNm: '', // 과정 분류명
            depthClsfNm: '', // 과정 분류명(뎁스)
            clsfCd: '', // 과정 분류 코드
            searchText: '' // 통합검색어
          }
        }
      },
      actions: {
        async ACT_TOTAL_SEARCH_LIST ({commit, state}, payload) {
          try {
            const result = await $fetchHttpData(payload.http, 'selectTotalSearchList', payload.param)

            // 중복 체크
            const uniqueKeysSet = new Set(
              state.resultInfo.corsList.map(item => `${item.eduGrpCd}-${item.corsCd}-${item.corsYr}-${item.corsDgrCd}`)
            )

            if (result.data && result.data.courseList) {
              const filteredList = result.data.courseList.filter(item => {
                const key = `${item.eduGrpCd}-${item.corsCd}-${item.corsYr}-${item.corsDgrCd}`
                return !uniqueKeysSet.has(key)
              })
              commit('SET_TOTAL_RESULT_INFO', {filteredList, totCnt: result.data.totCnt})
            } else {
              commit('SET_TOTAL_RESULT_INFO', {filteredList: [], totCnt: 0})
            }
          } catch (error) {
            console.error('Error fetching courseList :', error)
          }
        },
        async ACT_CORS_SEARCH_LIST ({commit, state}, payload) {
          try {
            const result = await $fetchHttpData(payload.http, 'selectCourseList', payload.param)
            // console.log('ACT_CORS_SEARCH_LIST result ------------->', result)
            if (!isEmpty(result.data) && result.data.courseList) {
              // ;와 #를 ,로 치환
              result.data.courseList.forEach(obj => {
                if (obj && obj.srchKwrdCntnt) {
                  obj.srchKwrdCntnt = obj.srchKwrdCntnt.replace(/;|#/g, ',')
                }
              })
              console.log('ACT_CORS_SEARCH_LIST result After ------------->', result)

              const courseList = result.data.courseList
              const totCnt = (courseList.length > 0) ? courseList[0].totCnt : 0

              commit('SET_CORS_RESULT_INFO', {courseList: courseList, totCnt, clsfNm: result.data.clsfNm, depthClsfNm: result.data.depthClsfNm, bannerList: result.data.bannerList})
            } else {
              commit('SET_CORS_RESULT_INFO', {courseList: [], totCnt: 0, clsfNm: result.data.clsfNm, depthClsfNm: result.data.depthClsfNm, bannerList: []})
            }
          } catch (error) {
            console.error('Error fetching course list:', error)
          }
        }
      }
    })

    // local vuex 용 vue instance 추가
    localStore = new Vue({
      store: store
    })
  }

  return localStore
}

var store = {}
store.getName = getName
store.createInstance = createInstance

export default store



// WEBPACK FOOTER //
// ./src/config/vuex/nrw/courseList.js